export const localUrl = location.origin;
